import React from 'react';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider/index.js';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { SmartCreatePageEditorLoader } from '@confluence/smart-create-page-editor';

import { navdexEnd } from '../naxdev.js';

export const EditPageSmartCreateRoute: {
	({
		params: { contentId },
		query: { iframeHostProduct, sharedFeaturesInstrumentationId },
	}: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { contentId, spaceKey } }: RouteMatch): {
		Screen: {
			showPremiumOnboarding: boolean;
			screenEvent: {
				attributes: {
					navdexPointType: string;
				};
				name: string;
				id: string;
			};
			pageState: {
				contentId: string;
				spaceKey: string;
				contentType: string;
			};
		};
		MainLayout: boolean;
		BannerContext: {
			includeTopNav: boolean;
		};
	};
} = ({
	params: { contentId },
	query: { iframeHostProduct, sharedFeaturesInstrumentationId },
}: RouteMatch): React.JSX.Element => {
	const iframeHostProductParam =
		typeof iframeHostProduct === 'string' ? iframeHostProduct : undefined;
	const sharedFeaturesInstrumentationIdParam =
		typeof sharedFeaturesInstrumentationId === 'string'
			? sharedFeaturesInstrumentationId
			: undefined;

	return (
		<ClassicEditorContextProviderLoader>
			<SmartCreatePageEditorLoader
				key={contentId}
				contentId={contentId}
				iframeHostProduct={iframeHostProductParam}
				sharedFeaturesInstrumentationId={sharedFeaturesInstrumentationIdParam}
			/>
		</ClassicEditorContextProviderLoader>
	);
};

EditPageSmartCreateRoute.NAVIGATION_PARAMS = ({
	params: { contentId, spaceKey },
}: RouteMatch): {
	Screen: {
		showPremiumOnboarding: boolean;
		screenEvent: {
			attributes: {
				navdexPointType: string;
			};
			name: string;
			id: string;
		};
		pageState: {
			contentId: string;
			spaceKey: string;
			contentType: string;
		};
	};
	MainLayout: boolean;
	BannerContext: {
		includeTopNav: boolean;
	};
} => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'editPageSmartCreateScreen',
			id: contentId,
			...navdexEnd,
		},
		pageState: { contentId, spaceKey, contentType: 'page' },
	},
	MainLayout: false,
	BannerContext: { includeTopNav: false },
});
